<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12" id="divMainFilter">
          <div class="row">
            <div class="col-sm-8">
              <label>Journals</label>
              <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                <option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.Acronym}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Volume</label>
              <select id="lstVolume" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of volumeList" value={{item.ID}}>
                  {{item.Volume}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Issue</label>
              <select id="lstIssue" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of issueList" value={{item.ID}}>
                  {{item.Issue}}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="FromDate" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="ToDate" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>Skip Date Filter</label>
              <input type="checkbox" id="chkSkipDate" />
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" id="btnLoadList" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>
        <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>

        <table #dataTable class="display" style="width:100%" id="articleStatusReceivedTable"></table>
      </div>
    </div>
  </div>
</div>
